module.exports = __webpack_public_path__ + "img/vip.a805c665.png";